import { PlusOutlined } from '@ant-design/icons';
import { Flex } from '@revenuemarket/cds';
import { colorTokens, colors } from '@revenuemarket/design';
import { Alert, Typography } from 'antd';
import { ManageButton } from '~components/DataManage/Onboarding/ManageButton';

interface Props {
  children?: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  alertInfo?: {
    title: string;
    description: string;
  } | null;
  onAdd?: () => void;
  actionButton?: React.ReactNode;
}
const DataManageContent: React.FC<Props> = ({
  children,
  title,
  description,
  alertInfo,
  onAdd,
  actionButton,
}) => {
  return (
    <Flex
      direction="column"
      style={{
        padding: 24,
        background: colors.grayscaleWhite,
        borderRadius: 6,
      }}
      gap={24}
    >
      <Flex justify="space-between">
        <Flex direction="column" gap={8}>
          {typeof title === 'string' ? (
            <Typography.Title level={4}>{title}</Typography.Title>
          ) : (
            title
          )}
          <Typography.Text
            style={{
              color: colorTokens.textDescription,
              fontSize: 14,
            }}
          >
            {description}
          </Typography.Text>
        </Flex>
        {actionButton || (
          <ManageButton type="primary" icon={<PlusOutlined />} onClick={onAdd}>
            연결
          </ManageButton>
        )}
      </Flex>
      {alertInfo && (
        <Alert
          showIcon
          type="info"
          message={alertInfo.title}
          description={alertInfo.description}
          banner
        />
      )}

      {children}
    </Flex>
  );
};

export default DataManageContent;
